import React from "react";
import { Link } from 'react-router-dom'

const Nav = ({ active }) => {

    const users = (active === "users" || active === "adduser" || active === "addpoint" || active === "delpoint" || active === "editname")? "active":""
    const privilege = (active === "privilege")? "active":""
    const product = (active === "product")? "active":""
    const productInventory = (active === "productInventory")? "active":""
    const spare = (active === "spare")? "active":""
    const promotion = (active === "promotion")? "active":""
    const document = (active === "document")? "active":""
    const catalog = (active === "catalog")? "active":""
    const point = (active === "point")?"active":""

    return (
        <div>
            <div className="admin-nav">
                <div className="nav-inner">
                    <ul>
                        <li className={users}><Link to="/admin" className={users}>ลูกค้า</Link></li>
                        <li className={privilege}><Link to="/admin/privilege" className={privilege}>สิทธิพิเศษ</Link></li>
                        <li className={product}><Link to="/admin/product" className={product}>สินค้า</Link></li>
                        <li className={productInventory}><Link to="/admin/product-inventory" className={productInventory}>สินค้าหมด</Link></li>
                        <li className={spare}><Link to="/admin/spare" className={spare}>อะไหล่</Link></li>
                        <li className={promotion}><Link to="/admin/promotion" className={promotion}>โปรโมชั่น</Link></li>
                        <li className={document}><Link to="/admin/document" className={document}>ดาวน์โหลดเอกสาร</Link></li>
                        <li className={catalog}><Link to="/admin/catalog" className={catalog}>แคตตาล็อก</Link></li>
                        <li className={point}><Link to="/admin/point" className={point}>คะแนน (Log)</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}



export { Nav }